import { createContext, Dispatch, SetStateAction, useContext } from 'react';

import {
  AddressInput,
  DeepPartial,
  HeatPumpIndoorUnit,
  HeatPumpOutdoorUnit,
  NewOfferExpenses,
  Residence,
  ResidenceInput,
  SelectedOfferProducts,
  TakeoverType,
} from '~src/model';

export type PublicCalculatorContext = {
  residence?: Omit<ResidenceInput, 'address'>;
  setResidence?: (input: DeepPartial<Residence>) => void;

  address?: Partial<AddressInput>;
  setAddress?: (address: Partial<AddressInput>) => void;

  showResidenceInputFields?: boolean;
  setShowResidenceInputFields?: (editable: boolean) => void;

  outdoorUnits?: HeatPumpOutdoorUnit[];
  indoorUnits?: HeatPumpIndoorUnit[];

  offerProducts?: SelectedOfferProducts;
  setOfferProducts?: (offers: SelectedOfferProducts) => void;

  solarPackageDiscount?: number;
  setSolarPackageDiscount?: (discount: number) => void;

  financing: boolean;
  setFinancing?: (newFinancing: boolean) => void;

  isStandalone?: boolean;

  visitedStageMap: Record<number, boolean>;
  setVisitedStageMap?: (stage: number) => void;

  openStageMap: Record<number, boolean>;
  setOpenStageMap?: Dispatch<SetStateAction<Record<number, boolean>>>;

  newOfferExpenses?: NewOfferExpenses;

  stage: number;
  setStage: Dispatch<SetStateAction<number>>;

  headerExpanded: boolean;
  setHeaderExpanded: Dispatch<SetStateAction<boolean>>;

  takeover?: TakeoverType;
};

const PublicCalculatorContext = createContext<PublicCalculatorContext>({
  financing: false,

  indoorUnits: [],
  outdoorUnits: [],

  visitedStageMap: {},
  openStageMap: {},

  solarPackageDiscount: 0,

  stage: 0,
  setStage: () => null,

  headerExpanded: false,
  setHeaderExpanded: () => null,
});

export const PublicCalculatorContextProvider = PublicCalculatorContext.Provider;

export const usePublicCalculatorContext = () => useContext(PublicCalculatorContext);
